// extracted by mini-css-extract-plugin
module.exports =  {"alert":"_25d45facb5--alert--i6PMY","close":"_25d45facb5--close--S2hMD","alert-padding":"_25d45facb5--alert-padding--Q3hGy","container":"_25d45facb5--container--yWLSV"};